// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__ESFOutro from "./ESFOutro.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function ESF(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const intl = ReactIntl.useIntl();
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h1", {
            children: "Электронный Акт выполненных работ",
            className: "h3 lg:h1 lg:flex lg:m-auto lg:text-center lg:w-200 text-white"
          }),
          JsxRuntime.jsx("p", {
            children: "Автоматизируйте работу с вашими заказчиками и поставщиками, то на что раньше тратились недели, делается за секунды.",
            className: "paragraph-large lg:h5 lg:flex lg:m-auto lg:text-center lg:w-200 mt-4 lg:mt-6 text-white"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "lg:w-148 lg:mt-4",
                alt: "work statement",
                src: deviceType === "mobile" ? StaticAsset.src("/static/images/work-statement.png") : StaticAsset.src("/static/images/work-statement-desktop.png")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "absolute z-1 top-2.75 lg:top-9 left-0.75",
                    alt: "flow lines",
                    src: StaticAsset.src("/static/images/flow-lines.svg")
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                        className: "-ml-4 -mt-1 z-2",
                        alt: "gray white circle",
                        src: StaticAsset.src("/static/icons/gray-white-circle.svg")
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("h6", {
                            children: "Вы",
                            className: "h6 lg:h5 text-white"
                          }),
                          JsxRuntime.jsx("p", {
                            children: "Вы делаете Акт выполненных работ в Бухте в ручном режиме или с помощью интеграции и он сразу же попадает в государственную систему учета актов выполненных работ. Вы можете сразу же отправить Акт вашему клиенту по почте.",
                            className: "paragraph text-white opacity-40 mt-2"
                          })
                        ],
                        className: "lg:w-88"
                      })
                    ],
                    className: "flex items-start mt-8"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                        className: "-ml-4 -mt-1 z-2",
                        alt: "gray white circle",
                        src: StaticAsset.src("/static/icons/gray-white-circle.svg")
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("h6", {
                            children: "Акт выполненых работ",
                            className: "h6 lg:h5 text-white"
                          }),
                          JsxRuntime.jsx("p", {
                            children: "Государственная система учета актов выполненных работ \"ИС ЭСФ\" получает ваш Акт и учитывает его.",
                            className: "paragraph text-white opacity-40 mt-2"
                          })
                        ],
                        className: "lg:w-88"
                      })
                    ],
                    className: "flex items-start mt-6"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                        className: "-ml-4 -mt-1 z-2",
                        alt: "gray white circle",
                        src: StaticAsset.src("/static/icons/gray-white-circle.svg")
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("h6", {
                            children: "Контрагент",
                            className: "h6 lg:h5 text-white"
                          }),
                          JsxRuntime.jsx("p", {
                            children: "Ваш клиент автоматически получает ваш акт в свою учетную систему. Либо получает ее в ручном режиме через свой кабинет в ИС ЭСФ, если у него нет учетной системы.",
                            className: "paragraph text-white opacity-40 mt-2"
                          })
                        ],
                        className: "lg:w-88"
                      })
                    ],
                    className: "flex items-start mt-6"
                  })
                ],
                className: "mt-8 lg:mt-0 relative"
              })
            ],
            className: "lg:flex lg:m-auto mt-8 lg:mt-20 justify-between lg:w-252"
          }),
          JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
            classes: {
              hd: "flex m-auto mt-10 lg:mt-25",
              tl: /* [] */ 0
            },
            label: Buhta_landing__I18n.trans(intl, "start_using"),
            onClick: (function (param) {
              Buhta_landing__EventHandlers.scrollToFooter(deviceType);
            })
          }),
          JsxRuntime.jsx("p", {
            children: "Уже пользуются 125 предпринимателей",
            className: "paragraph-small text-center text-gray-landing mt-4"
          })
        ],
        className: "bg-black-landing py-16 lg:py-40 px-6 sm:px-48 lg:px-0"
      }),
      JsxRuntime.jsx(Buhta_landing__ESFOutro.make, {})
    ]
  });
}

const make = ESF;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
